import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const InspectionsView = lazy(async () => {
  const m = await import("@/features/inspections/components/inspections-view");
  return { default: m.InspectionsView };
});

export interface InspectionsSearch {
  /** Deep-link: pre-select a status filter. */
  status?: string;
  /** Deep-link: scope inspections to a single site (e.g. from a site row). */
  siteId?: string;
  /** Deep-link: scope inspections to a single template. */
  templateId?: string;
  /** Deep-link: open the "new inspection" dialog. */
  new?: string;
}

export const inspectionsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/inspections",
  validateSearch: (search: Record<string, unknown>): InspectionsSearch => ({
    status: typeof search.status === "string" ? search.status : undefined,
    siteId: typeof search.siteId === "string" ? search.siteId : undefined,
    templateId: typeof search.templateId === "string" ? search.templateId : undefined,
    new: search.new === "inspection" ? "inspection" : undefined,
  }),
  component: () => (
    <Suspense fallback={null}>
      <InspectionsView />
    </Suspense>
  ),
});
